import { signal, Motion } from "zyra";
export function CounterDemo() {
  const count = signal(0);
  return (
    <div class="live-demo">
      <div class="demo-top">
        <span>
          <i /> LIVE EXAMPLE
        </span>
        <span>Built with Zyra</span>
      </div>
      <div class="demo-stage">
        <div class="orbit orbit-one" />
        <div class="orbit orbit-two" />
        <Motion.button
          class="counter"
          hover={{ scale: 1.04 }}
          press={{ scale: 0.96 }}
          onClick={() => count.value++}
        >
          <span class="counter-icon">↗</span>
          <span>Count: {count.value}</span>
          <span class="counter-plus">+</span>
        </Motion.button>
        <p>One signal. One precise update.</p>
      </div>
      <div class="demo-bottom">
        <span>Component setup runs once.</span>
        <button
          onClick={() => {
            count.value = 0;
          }}
        >
          Reset ↺
        </button>
      </div>
    </div>
  );
}
